"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["color", "size"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Link = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  var {
    color,
    size
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    fill: color
  }, rest), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("style", null, ".a{fill:none;}.b{fill:#4a4a4a;}")), /*#__PURE__*/_react.default.createElement("defs", null), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(52 -51.573)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    className: "a",
    width: "16",
    height: "16",
    transform: "translate(-52 51.573)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M-31.813,58.147a2.931,2.931,0,0,0-3.954-.652.486.486,0,0,0-.058.743h0a.488.488,0,0,0,.616.056,1.955,1.955,0,0,1,2.711.571,1.987,1.987,0,0,1-.3,2.479l-3.8,3.8a1.986,1.986,0,0,1-2.479.3,1.954,1.954,0,0,1-.32-3.019l.345-.345a.488.488,0,0,0,0-.69h0a.487.487,0,0,0-.69,0l-.251.25a3.025,3.025,0,0,0-.01,4.314,2.891,2.891,0,0,0,1.974.774,2.94,2.94,0,0,0,2.08-.856l3.81-3.81A3,3,0,0,0-31.813,58.147Z",
    transform: "translate(-5.695 -2.567)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M-49.66,67.867a1.989,1.989,0,0,1,.3-2.481l3.781-3.78a2.053,2.053,0,0,1,2.741-.132,1.923,1.923,0,0,1,.643,1.551,2.114,2.114,0,0,1-.648,1.367l-.6.6a.488.488,0,0,0,0,.69h0a.488.488,0,0,0,.69,0l.6-.6a3.01,3.01,0,0,0,.139-4.177,2.914,2.914,0,0,0-2.366-.9,3.091,3.091,0,0,0-1.91.931l-3.7,3.7A3.024,3.024,0,0,0-50,68.961a2.887,2.887,0,0,0,1.971.772,2.971,2.971,0,0,0,1.647-.5.484.484,0,0,0,.056-.74l0,0a.488.488,0,0,0-.616-.056A1.958,1.958,0,0,1-49.66,67.867Z",
    transform: "translate(-0.561 -4.107)"
  })));
});
Link.propTypes = {
  color: _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onClick: _propTypes.default.func
};
Link.defaultProps = {
  color: 'currentColor',
  size: '1em',
  onClick: () => {}
};
var _default = Link;
exports.default = _default;